/** Number and currency formatters shared across usage/billing/admin views. */

/** Thousands-separated integer, e.g. "1,204,331". */
export function formatNumber(n: number): string {
  return n.toLocaleString()
}

/** USD with a fixed number of fraction digits, e.g. "$4.20" / "$0.0031". */
export function formatUsd(usd: number, digits = 2): string {
  return `$${usd.toFixed(digits)}`
}
